import axios from 'axios';

//const axiosInstance = axios.create();

const axiosInstance = axios.create({
  // baseURL:'http://localhost:3001/',
  // baseURL:'http://15.165.31.210:3001/',
  // baseURL:'https://api-oneword.sothecode.com/',
  baseURL:'https://api-app.lognlook.com/',
  timeout: 3000,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
